module.exports = __webpack_public_path__ + "static/media/lettuce_hero.8adbf67a.jpg";